import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteCategory = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const deleteCategory = (id: string) => {
        const { exec } = userApi.deleteDocumentCategory({
            params: { id },
            onSuccess: () => {
                toastHandler.push(`success`, t('categories.deleteTitle'), t('categories.deleteSuccess'));
            },
            onError: () => toastHandler.push(`error`, t('categories.deleteTitle'), t('categories.deleteError')),
        });
        exec();
    };

    return { exec: deleteCategory };
};

export default useHttpDeleteCategory;
